import { Tooltip } from './contentTooltip.model';
import { ContentVacationTrip } from './contentvacationtrip.model';
import { ContentCarTrip } from './contentcartrip.model';
import { ContentFlightTrip } from './contentflighttrip.model';

export class ContentMyTrip {
  id: any;
  label: any;
  mytripslastname: any;
  mytripsHotelreservationUrl: any;
  mytripsCarReservationUrl: any;
  mytripsHotelreservationLabel: any;
  mytripsCarReservationLabel: any;
  mytripsfirstname: any;
  mytripsHotelreservationTarget: any;
  mytripsCarReservationTarget: any;
  mytripsRegexPattern: any;
  mytripsWhereToFindUrl: any;
  mytripsWhereToFindLabel: any;
  mytripssubmiturl: any;
  mytrips: Map<string, ContentMyTripItem>;
  mytripslastnameFloat: any;
  mytripsFirstNameFloat: any;
  findYourTripBy: any;
  tooltips: Map<string, Tooltip> = new Map();
  vacationTrip: ContentVacationTrip;
  carTrip: ContentCarTrip;
  flightTrip: ContentFlightTrip;
  backToUpcomingTripLabel: any;
  legacyAppUrl: string;
  headerPciChanges?: boolean;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['label']) {
        this.label = contentjson['label'];
      }
      if (contentjson['mytripLastNameFloat']) {
        this.mytripslastnameFloat = contentjson['mytripLastNameFloat'];
      }
      if (contentjson['mytripsFirstNameFloat']) {
        this.mytripsFirstNameFloat = contentjson['mytripsFirstNameFloat'];
      }
      if (contentjson['mytripsLastName']) {
        this.mytripslastname = contentjson['mytripsLastName'];
      }
      if (contentjson['mytripsHotelReservationUrl']) {
        this.mytripsHotelreservationUrl =
          contentjson['mytripsHotelReservationUrl'];
      }
      if (contentjson['mytripsCarReservationUrl']) {
        this.mytripsCarReservationUrl = contentjson['mytripsCarReservationUrl'];
      }
      if (contentjson['mytripsHotelReservationLabel']) {
        this.mytripsHotelreservationLabel =
          contentjson['mytripsHotelReservationLabel'];
      }
      if (contentjson['mytripsCarReservationLabel']) {
        this.mytripsCarReservationLabel =
          contentjson['mytripsCarReservationLabel'];
      }
      if (contentjson['mytripsFirstName']) {
        this.mytripsfirstname = contentjson['mytripsFirstName'];
      }
      if (contentjson['findYourTripBy']) {
        this.findYourTripBy = contentjson['findYourTripBy'];
      }
      if (contentjson['mytripsHotelReservationTarget']) {
        this.mytripsHotelreservationTarget =
          contentjson['mytripsHotelReservationTarget'];
      }
      if (contentjson['mytripsCarReservationTarget']) {
        this.mytripsCarReservationTarget =
          contentjson['mytripsCarReservationTarget'];
      }
      if (contentjson['mytripsRegexPattern']) {
        this.mytripsRegexPattern = contentjson['mytripsRegexPattern'];
      }
      if (contentjson['submitUrl']) {
        this.mytripssubmiturl = contentjson['submitUrl'];
      }
      if (contentjson['backToUpcomingTripLabel']) {
        this.backToUpcomingTripLabel = contentjson['backToUpcomingTripLabel'];
      }
      if (contentjson['mytrips']) {
        this.mytrips = this.fillcontentMyTripsItem(contentjson['mytrips']);
      }
      if (contentjson['mytripsWhereToFindUrl']) {
        this.mytripsWhereToFindUrl = contentjson['mytripsWhereToFindUrl'];
      }
      if (contentjson['mytripsWhereToFindLabel']) {
        this.mytripsWhereToFindLabel = contentjson['mytripsWhereToFindLabel'];
      }
      if (contentjson['toolTipDetails']) {
        this.fillTooltipData(contentjson['toolTipDetails']);
      }
      if (contentjson['mytripsLoggedIn']) {
        this.fillmyTripsLoggedInData(contentjson['mytripsLoggedIn']);
      }
      if (
        contentjson['legacyAppUrl'] &&
        contentjson['legacyAppUrl'].trim() !== ''
      ) {
        this.legacyAppUrl = contentjson['legacyAppUrl'];
      }
      if (contentjson['headerPciChanges']) {
        this.headerPciChanges = contentjson['headerPciChanges'];
      }
    }
  }

  private fillcontentMyTripsItem(contentjson?: any) {
    const mytripItem: Map<string, ContentMyTripItem> = new Map();
    const items = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      for (const value of values) {
        mytripItem.set(
          value['mytripsSearchById'],
          new ContentMyTripItem(value['mytripsSearchById'], value)
        );
      }
    }
    return mytripItem;
  }

  private fillTooltipData(tooltipArray?: any) {
    this.tooltips = new Map();
    if (tooltipArray) {
      for (const tooltip of tooltipArray) {
        this.tooltips.set(tooltip['itemId'], new Tooltip(tooltip));
      }
    }
  }

  private fillmyTripsLoggedInData(myTripsLoggedInArray?: any) {
    if (myTripsLoggedInArray['vacation']) {
      this.vacationTrip = new ContentVacationTrip(
        myTripsLoggedInArray['vacation']
      );
    }
    if (myTripsLoggedInArray['carReservation']) {
      this.carTrip = new ContentCarTrip(myTripsLoggedInArray['carReservation']);
    }
    if (myTripsLoggedInArray['upComingtTrips']) {
      this.flightTrip = new ContentFlightTrip(
        myTripsLoggedInArray['upComingtTrips']
      );
    }
  }
}

export class ContentMyTripItem {
  id: any;
  mytripssearchbytitle: any;
  mytripssearchbyid: any;
  mytripseacrhbynumber: any;
  searchtripsFloatLabel: any;
  mytripSearchByType: any;

  constructor(item: any, contentjson?: any) {
    this.id = item;
    if (contentjson) {
      if (contentjson['mytripsSearchByTitle']) {
        this.mytripssearchbytitle = contentjson['mytripsSearchByTitle'];
      }
      if (contentjson['mytripsSearchById']) {
        this.mytripssearchbyid = contentjson['mytripsSearchById'];
      }
      if (contentjson['mytripSearchByNumber']) {
        this.mytripseacrhbynumber = contentjson['mytripSearchByNumber'];
      }
      if (contentjson['mytripSearchByType']) {
        this.mytripSearchByType = contentjson['mytripSearchByType'];
      }
      if (contentjson['searchTripsFloatLabel']) {
        this.searchtripsFloatLabel = contentjson['searchTripsFloatLabel'];
      }
    }
  }
}
